import { orderBy } from 'lodash'
import { IntentId, NlpModel } from '@feedyou/schema'
import { AnalysisWarning, AnalysisWarningType, UtteranceClassification } from '@feedyou/utils'

import { scoreToText } from '../../lib/nlp'
import { getModelForIntentId } from '../../components/nlp/TrainingTab/components/TrainingTab/components/implementations/NlpModel/utils'

export const isOfType =
  <Type extends AnalysisWarningType>(type: Type) =>
  (warning: AnalysisWarning): warning is Extract<AnalysisWarning, { type: Type }> => {
    return warning.type === type
  }

export const isForIntent =
  (id: IntentId) =>
  (classification: UtteranceClassification): boolean => {
    return classification.intent === id
  }

export const generateBootboxReportFromClassifications = (
  models: NlpModel[],
  classifications: UtteranceClassification[]
) => {
  // Ignore classifications below 0.1 to avoid reporting all unmatched intents with ~0.0 score
  const validClassificationsFromHighest = orderBy(classifications, 'score', 'desc').filter(
    classification => classification.score > 0.1
  )

  return validClassificationsFromHighest.length
    ? validClassificationsFromHighest
        .map(
          ({ intent, score }) =>
            `Intent <strong>${intent}</strong> from NLP model <strong>${
              getModelForIntentId(intent, models)?.id
            }</strong> with confidence ${scoreToText(score)}`
        )
        .join('<br>')
    : "This utterance didn't match any intent"
}
